import React from "react";
import { Card } from "react-bootstrap";
import Button from "app/storybookComponents/Button";
import { getLogo } from "./helpers";

interface CheckInEmailReportProps {
  onChatClick?: () => void;
}

const CheckInEmailReport: React.FC<CheckInEmailReportProps> = ({
  onChatClick,
}: Readonly<CheckInEmailReportProps>) => (
  <Card className="padding-20px raw-email-html">
    {getLogo()}
    <hr />
    <div className="sample-email-reports-body">
      <p>Hey Jessica,</p>
      <p>How was your week? I'd love to hear:</p>
      <ul className="m-0 check-in-response-list">
        <li>What you've been working on</li>
        <li>How it's going</li>
        <li>Any wins to celebrate or blockers to talk through</li>
      </ul>
      <p>
        <b>
          Unlike our normal conversations, I will potentially share some of
          these manager updates with your manager and other leaders in your
          company so they can better celebrate or support you.
        </b>
      </p>
      <div className="row-gap-12px">
        <Button onClick={onChatClick}>Chat with Coach Bo</Button>
      </div>
    </div>
  </Card>
);

export default CheckInEmailReport;
